interface ViewItem {
    id: string,
    el: HTMLElement
}

interface ViewSwitcherEvent {
    id: string,
    view?: ViewItem
}

export default class ViewSwitcher {
    private readonly views: Array<ViewItem> = [];
    private activeViewIndex: number;

    private listeners: Record<string, Array<(params: ViewSwitcherEvent) => void>> = {};

    constructor(views: Array<ViewItem>) {
        this.views = views;
        this.show(0);
    }

    public getViewIndex(id): number {
        return typeof id === 'string' ? this.views.findIndex(v => v.id === id) : id;
    }

    public getView(id: number|string): ViewItem {
        return this.views[this.getViewIndex(id)];
    }

    public show(id: number|string) {
        const viewIndex = this.getViewIndex(id);

        if (this.views.length === 0 || this.activeViewIndex === viewIndex) {
            return;
        }

        const view = this.getView(id);

        this.views.forEach(v => v.el.style.display = 'none');

        view.el.style.display = 'block';
        this.activeViewIndex = viewIndex;

        this.emit({
            id: 'activated',
            view: view
        });
    }

    public emit(event: ViewSwitcherEvent) {
        if (typeof this.listeners[event.id] !== 'undefined') {
            this.listeners[event.id].forEach(l => l(event));
        }
    }

    public on(event: string, callback: (params: ViewSwitcherEvent) => void) {
        if (typeof this.listeners[event] === 'undefined') {
            this.listeners[event] = [callback];
        } else {
            this.listeners[event].push(callback);
        }
    }
}